import { LRLanguage, LanguageSupport } from '@codemirror/language';
import { javascriptLanguage } from '@codemirror/lang-javascript';
import { parseMixed } from '@lezer/common';
import { parser } from './parser';

// Redefine a copy of the javascript language without its extensions to be used
// inside templates
export const javascriptInnerLanguage = LRLanguage.define({
  name: 'javascript-inner',
  parser: javascriptLanguage.parser,
  languageData: javascriptLanguage.data,
});

// Define a bew jsTemplate language
export const jsTemplateLanguage = LRLanguage.define({
  name: 'jsTemplate',
  parser: parser.configure({}),
  languageData: {},
});

// Create a LanguageSupport object for the jsTemplate language, which parses its
// inner TemplateContent using the javascriptInnerLanguage parser
export function jsTemplate() {
  return new LanguageSupport(
    jsTemplateLanguage.configure({
      wrap: parseMixed(node => {
        return node.name === 'TemplateContent'
          ? {
              parser: javascriptInnerLanguage.parser.configure({
                top: 'SingleExpression',
              }),
            }
          : null;
      }),
    }),
    [],
  );
}
